import { useI18n, t } from "@bookingcom/lingojs-react";

export const useViewPriceDetailsController = () => {
  const i18n = useI18n();

  return {
    text: i18n.trans(t("flights_book_process_view_price_details_cta")),
    modal: {
      title: i18n.trans(t("flights_price_details_title")),
      closeAriaLabel: i18n.trans(t("a11y_flights_close_price_details"))
    }
  };
};
